<template>
  <div class="subscription-admin-banner">
    <BaseSubHeading
      size="small"
      weight="400"
      color="monochrome-06"
    >
      {{ remainingDays }} Left in the Free Trial |&nbsp;
    </BaseSubHeading>
    <BaseSubHeading
      size="small"
      weight="600"
      color="monochrome-06"
    >
      {{ currentPlan.productName }} Plan
    </BaseSubHeading>
    <button
      v-if="!isSuperAdmin"
      class="inner-banner__close"
      type="button"
      @click="hideBanner"
    >
      <icon
        data="@icon/close2.svg"
        :fill="true"
        width="var(--icon-16)"
        height="var(--icon-16)"
      />
    </button>
  </div>
</template>

<script lang="ts" setup>
import { useAcl } from "vue-simple-acl"
import { isBefore } from "date-fns"
import { computed } from "vue"
import { useStore } from "vuex"

import { StripePrice } from "@/models"
import { Getters } from "@/store"
import { getTrialRemainingLabel, toDate } from "@/utils/dateUtil"

const props = defineProps({
  trialEndDate: {
    type: String,
    required: true
  }
})

const store = useStore()

const currentPlan = computed((): StripePrice => {
  return store.getters[Getters.CURRENT_STRIPE_PRICE]
})

const isSuperAdmin = computed(() => {
  return useAcl().can("superAdmin")
})

const remainingDays = computed(() => {
  if (isBefore(toDate(props.trialEndDate), new Date())) return "0 Days"
  return getTrialRemainingLabel(props.trialEndDate)
})
</script>

<style scoped lang="scss">
@import "@/assets/scss/utils/mixins/_flex";

.subscription-admin-banner {
  @include flex($justify: center, $align: center);

  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
}
</style>
